<script setup lang="ts">
import { Segment } from "@/modules/rule_engine/describe";

/**
 * Renders a described rule as styled text.
 *
 * The only place segment kinds get visual meaning, so the rule list, group
 * previews and the version comparison all read the same.
 */
defineProps<{
	/** Leading connector, e.g. IF / AND / THEN. */
	connector?: string;
	segments: Segment[];
}>();
</script>

<template>
	<span class="rule-segments">
		<span v-if="connector" class="connector">{{ connector }}</span>
		<span
			v-for="(segment, index) in segments"
			:key="index"
			:class="`segment segment--${segment.kind}`"
			>{{ segment.text }}</span
		>
	</span>
</template>

<style scoped lang="scss">
.rule-segments {
	display: inline-flex;
	flex-wrap: wrap;
	align-items: baseline;
	gap: 0.35rem;
	line-height: 1.6;
}

.connector {
	font-size: 0.7rem;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: rgb(var(--v-theme-primary));
	opacity: 0.75;
	min-width: 2.4rem;
}

.segment--dimension {
	font-weight: 600;
}

.segment--operator {
	opacity: 0.75;
}

.segment--value {
	font-weight: 600;
}

.segment--keyword {
	font-weight: 600;
}

.segment--text {
	opacity: 0.75;
}
</style>
